


















import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { MigrationImport } from "@/entities";
import TableComponent from "./Components/PersonnelTable.vue";
import FormattedNumber from "@/components/common/Inputs/FormattedNumber.vue";

const namespace: string = "migration";

@Component({
  components: {
    TableComponent,
    FormattedNumber,
  },
})
export default class PersonnelCostComponent extends Vue {
  @State(namespace) migration!: MigrationImport;

  @Prop() schema: any;
  @Prop() model: any;
  @Prop() currency: string;
  @Prop() readonly: any;
  @Prop() formOptions: any;

  currencyList: any = [];

  get header() {
    if (this.schema && this.schema.personnelHeaders) {
      return this.schema.personnelHeaders.items;
    }
  }

  get dataModel() {
    if (!this.model.personnelCost) {
      this.model.personnelCost = [];
    }
    return this.model.personnelCost;
  }
}
